import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  GetCaseBlacklistableIdentifiersQuery,
  GetCaseBlacklistableIdentifiersQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { blacklistableIdentifierFragment } from "src/graphql/anti-fraud/fragments/BlacklistableIdentifierFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToBlacklistableCaseIdentifier } from "src/mappers/case.mappers.ts";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getCaseBlacklistableIdentifiersQuery = gql`
  query GetCaseBlacklistableIdentifiers($id: ID!, $includeLinkedCaseIdentifiers: Boolean!) {
    case(id: $id) {
      blacklistableIdentifiers(includeLinkedCaseIdentifiers: $includeLinkedCaseIdentifiers) {
        ...BlacklistableIdentifierFragment
      }
    }
  }

  ${blacklistableIdentifierFragment}
` as TypedDocumentNode<
  GetCaseBlacklistableIdentifiersQuery,
  GetCaseBlacklistableIdentifiersQueryVariables
>;

export const useGetBlacklistableIdentifiers = (
  options?: QueryHookOptions<
    GetCaseBlacklistableIdentifiersQuery,
    GetCaseBlacklistableIdentifiersQueryVariables
  >
) =>
  useFetchQuery(getCaseBlacklistableIdentifiersQuery, {
    toData: (data) =>
      data?.case?.blacklistableIdentifiers.map(mapToBlacklistableCaseIdentifier) ?? [],
    isEmpty: (data) => isEmpty(data?.case?.blacklistableIdentifiers),
    uiErrors: {
      fetchError: "FETCH-BLACKLIST-IDENTIFIERS-ERROR",
    },
    queryOptions: options,
  });
